import * as React from "react";

const LetterheadPageTemplate = (props) => {
  return (
    <div>
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "0",
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <img
            src={require("Assets/img/tsga-letterhead-logo.png")}
            alt="Tarun Sardesai Golf Academy"
            style={{ width: "120px", height: "auto" }}
          />
        </div>
        <div
          style={{
            margin: "8px 20px 0 20px",
            borderBottom: "1.5px solid #A4C22E",
          }}
        />
      </div>

      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: "-5",
          pointerEvents: "none",
        }}
      >
        <img
          src={require("Assets/img/tsga-letterhead-watermark.png")}
          alt=""
          style={{
            width: "65%",
            height: "auto",
            display: "block",
          }}
        />
      </div>
    </div>
  );
};

export default LetterheadPageTemplate;
